import React from 'react';
import { formatPrice } from '@jbhi-fi/lanyard-ui/global/utils';
import { styles } from './FulfilmentOption.css';
import TagType from '@jbhi-fi/lanyard-ui/components/Tag/types/tag.type';

export type FulfilmentOptionProps = {
  title: string;
  serviceImage?: string;
  serviceName?: string;
  experienceName?: string;
  description?: string;
  price?: number;
  isUnavailable: boolean;
  storeLink?: string;
  tags?: Array<{ type: TagType; content: string }>;
  isClickAndCollect?: boolean;
  importantMessaging?: string;
};

const FulfilmentOption = ({
  title,
  serviceImage,
  serviceName,
  experienceName,
  description,
  price,
  isUnavailable = false,
  storeLink,
  isClickAndCollect,
  importantMessaging,
}: FulfilmentOptionProps): JSX.Element => {
  return (
    <div className={styles.container}>
      <div className={styles.leftSide}>
        <p className={styles.title}>{title}</p>
        <div className={styles.subheading}>
          {serviceImage ? <img src={serviceImage} alt={serviceName} /> : null}
          {serviceImage && experienceName ? <p className={styles.neutral}>{experienceName}</p> : null}
          {isUnavailable ? <p className={styles.unavailable}>Unavailable</p> : null}
          {!experienceName && !isUnavailable && !description && !isClickAndCollect ? (
            <p className={styles.available}>Available</p>
          ) : null}
          {isClickAndCollect ? (
            <div className={styles.importantMessagingContainer}>
              <p className={styles.importantMessaging}>{importantMessaging}</p>
            </div>
          ) : null}
        </div>
        {description ? (
          <div className={styles.descriptionBlock}>
            {' '}
            <p>{description}</p>{' '}
          </div>
        ) : null}
        {storeLink ? (
          <div>
            <a href={storeLink} className={styles.link}>
              Check hours
            </a>
          </div>
        ) : null}
      </div>

      {price && !isUnavailable ? (
        <div>
          <p className={styles.title}>${formatPrice(price)}</p>
        </div>
      ) : null}
    </div>
  );
};

export default FulfilmentOption;
